//M10-12287
import uploadSvg from "src/assets/upload.svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Autocomplete, Button, Modal } from "src/components";
import { ordActions } from "src/context/order-slice";
import { addStockistAttachmentEvent, getAttachmentDetails, uploadStockistFile } from "src/services/invoice-api";
import { fetchStockistFilterData } from "src/services/order-api";  // M10-13711
import { toast } from "src/hooks/useToast";
import { RootState } from "src/context/store";
import MultiAutocompleteAsync from "src/components/ui/MultiAutocompleteAsync";
import { generateUniqueID } from "src/constants/functions";

type InvoiceUploadModalProps = {
  modalOpen: boolean;
  company_code?: any;
  order_code?: string;
  module_code?: any;
};

const InvoiceUploadModal = ({ modalOpen, company_code, order_code, module_code }: InvoiceUploadModalProps) => {
  const dispatch = useDispatch();
  const { OrdersFiltersData } = useSelector((state: RootState) => state.ord || []);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [company, setCompany] = useState<any>(company_code);
  const [orders, setOrders] = useState<any[]>([]);
  const [referenceNo, setReferenceNo] = useState(""); //M10-12287
  // M10-13711
  const [uploaderType, setUploaderType] = useState<"MV" | "NMV" | "KAM">("MV");
  const [stockistList, setStockistList] = useState<any[]>([]);
  const [nmvStockist, setNmvStockist] = useState<any>(null);
  const [nmvCheckbox, setNmvCheckbox] = useState<"patient" | "customer" | "">("");
  const [customerName, setCustomerName] = useState("");
  console.log(nmvStockist, "nmvStockist")
  const uploaderOptions = [
    { name: "Medvol", code: "MV" },
    { name: "Non Medvol", code: "NMV" },
    { name: "KAM", code: "KAM" }
  ];
  // M10-13711

  // --- Async function to fetch orders
  const fetchOrderDetailsAsync = async (query = "", pageNumber = 1) => {
    if (!company?.code) return [];
    try {
      const orderCode = query.includes(',') ? query.split(',')[1].trim() : query; //M10-12287
      const res = await getAttachmentDetails({
        company_code: company.code,
        order_code: orderCode,  //M10-12287
        page_number: pageNumber,
        page_size: 15,
        module_code: uploaderType == 'KAM' ? 4 : 1
      });
      return res?.data?.data || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  // --- Drag & Drop handler
  const onDropHandler = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (!file) return;
    if (file.type !== "application/pdf") {
      toast({ description: "Please upload a PDF file", variant: "destructive" });
      return;
    }
    setSelectedFile(file);
  };

  // --- File browse handler
  const allowedExtensions = ["pdf", "tiff", "tif", "bmp", "jpeg", "jpg", "png", "webp", "jpe"];

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (!ext || !allowedExtensions.includes(ext)) {
      toast({ description: "Invalid file type. Please upload a valid document or image.", variant: "destructive" });
      e.target.value = "";
      return;
    }
    setSelectedFile(file)
  };
  //M10-12287
  const validateOrders = (orders: any[]) => {
    if (!orders || orders.length <= 1) return true;

    const firstCounterCode = orders[0].counter_code;
    const firstStockistCode = orders[0].company_stockist_code;

    return orders.every(
      (order) =>
        order.counter_code === firstCounterCode &&
        order.company_stockist_code === firstStockistCode
    );
  };
  //M10-12287

  // --- Close modal
  const handleClose = () => {
    setSelectedFile(null);
    setCompany(undefined);
    setOrders([]);
    setReferenceNo("")  //M10-12287
    // M10-13711
    setUploaderType("MV");
    setNmvStockist(null);
    setStockistList([]);
    setNmvCheckbox("");
    setCustomerName("");
    setCustomerName("");
    // M10-13711
    dispatch(ordActions.setFileUpload(false));
  };

  // --- Upload file handler
  const HandleUpload = async () => {
    if (!selectedFile) {
      toast({ description: "Please select a file", variant: "destructive" });
      return;
    }

    // M10-13711
    if (!referenceNo || referenceNo.trim() === "") {
      toast({ description: "Please enter Reference No", variant: "destructive" });
      return;
    }

    if (uploaderType === "MV" || uploaderType === "KAM") {
      // Existing MV flow (KAM reuses the same flow, only adds module_code: 4)
      if (orders.some(o => ![0, 18, 2].includes(o?.orderStatusHdr?.order_status_id))) {
        toast({
          description: "Only orders with status ORDER_COMPLETED / ORDER_ESCALATED /PARTIALLY_INVOICED are allowed",
          variant: "destructive",
        });
        return;
      }

      if (!validateOrders(orders)) {
        toast({
          description: "Selected orders must belong to the same Counter and Stockist",
          variant: "destructive",
        });
        return;
      }

      const formData = new FormData();
      formData.append("stockist_uid", "0646cf88-3ec1-4268-ac7a-dc0f588be594");
      formData.append("company_short_name", company.shortname);
      formData.append("functionality", "INVOICE_ADD");
      formData.append("invoice_attachment", selectedFile);

      const fileupload = await uploadStockistFile(formData, company?.code);

      if (!fileupload?.data?.data) return;

      const payload = {
        data: {
          stockist_invoice_number: "",
          counter_code: orders?.[0]?.counter_code,
          company_code: orders?.[0]?.company_code,
          location_code: orders?.[0]?.novu_metadata?.counter_location_code,
          company_stockist_code: orders?.[0]?.company_stockist_code,
          fuid_no: fileupload.data.data.fuid_no,
          latitude: Number(orders?.[0]?.latitude),
          longitude: Number(orders?.[0]?.longitude),
          order_code: orders?.map(o => o.order_code).join(','), //M10-12287
          reference_no: referenceNo,  //M10-12287
          u_code: generateUniqueID(),
          uploader_type: "MV",  //M10-12287
          file_key: fileupload.data.data.uploaded_files?.invoice_attachment,  //M10-12287
          attachment_version: 'V2',  //M10-12287
          upload_type: "MV",
          ...(uploaderType === "KAM" && { module_code: 4 }),
        },
        event_type: "STOCKIST_ATTACHMENT_ADD",
      };

      await addStockistAttachmentEvent(payload, company?.code);
      toast({ description: `File Uploaded Successfully - ${fileupload.data.data.fuid_no}`, duration: 10000 });
      handleClose();
    } else {
      // NMV flow
      if (!nmvStockist) {
        toast({ description: "Please select a Stockist", variant: "destructive" });
        return;
      }
      if (!nmvCheckbox) {
        toast({ description: "Please select either Patient or Customer", variant: "destructive" });
        return;
      }
      if (!customerName.trim()) {
        toast({ description: nmvCheckbox === "patient" ? "Please enter Patient Name" : "Please enter Customer Name", variant: "destructive" });
        return;
      }

      const formData = new FormData();
      formData.append("stockist_uid", nmvStockist?.uid);
      formData.append("company_short_name", company.shortname);
      formData.append("functionality", "INVOICE_ADD");
      formData.append("invoice_attachment", selectedFile);

      const fileupload = await uploadStockistFile(formData, company?.code);

      if (!fileupload?.data?.data) return;

      const payload = {
        data: {
          stockist_invoice_number: "",
          counter_code: "",
          company_code: company?.code,
          location_code: 0,
          company_stockist_code: nmvStockist?.stockist_company_lnk?.[0]?.compStockistCode,
          fuid_no: fileupload.data.data.fuid_no,
          latitude: 0,
          longitude: 0,
          order_code: "",
          reference_no: referenceNo,
          u_code: generateUniqueID(),
          uploader_type: "MV",
          file_key: fileupload.data.data.uploaded_files?.invoice_attachment,
          attachment_version: 'V2',
          upload_type: "NMV",
          customer_type: nmvCheckbox === "patient" ? "P" : "C",
          customer_name: customerName,
        },
        event_type: "STOCKIST_ATTACHMENT_ADD",
      };

      await addStockistAttachmentEvent(payload, company?.code);
      toast({ description: `File Uploaded Successfully - ${fileupload.data.data.fuid_no}`, duration: 10000 });
      handleClose();
    }
  };
  // M10-13711

  useEffect(() => {
    if (!modalOpen) return;

    if (company_code) {
      setCompany(company_code);
    }
    if (module_code === 4) {
      setUploaderType("KAM");
    }
  }, [modalOpen, company_code, module_code]);

  useEffect(() => {
    if (!modalOpen) return;
    if (!company?.code || !order_code) return;

    const fetchInitialOrders = async () => {
      try {
        const data = await fetchOrderDetailsAsync(order_code, 1);
        setOrders(data || []);
      } catch (err) {
        console.error("Error fetching initial orders:", err);
      }
    };

    fetchInitialOrders();
  }, [modalOpen, company, order_code, uploaderType]);

  return (
    <Modal isHeader={true} isOpen={modalOpen} onCloseModal={handleClose} title="Invoice File Upload">
      <div className="w-[90vw] sm:w-[60vw] md:w-[40vw]">
        <div className="flex flex-col gap-4 px-5 pt-2 pb-4">
          {/*  M10-13711 */}
          {/* Uploader Type Dropdown */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700 mb-2">Uploader Type</label>
            <Autocomplete
              suggestionList={uploaderOptions}
              displayKey="name"
              placeholder="Select Uploader Type"
              defaultValue={uploaderOptions.find(opt => opt.code === uploaderType)}
              onSelectionChange={(value: any) => {
                setUploaderType(value?.code || "MV");
                setCompany(undefined);
                setOrders([]);
              }}
            />
          </div>
          {/*  M10-13711 */}
          {/* Company Dropdown */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700 mb-2">Company Name</label>
            <Autocomplete
              suggestionList={OrdersFiltersData?.company || []}
              displayKey="name"
              placeholder="Select Company Name"
              defaultValue={company}
              onSelectionChange={(value: any) => {
                setCompany(value);
                if (uploaderType === "NMV" && value?.code) {
                  setNmvStockist(null);
                  fetchStockistFilterData(value.code)
                    .then((res: any) => setStockistList(res?.data?.data?.data || []))
                    .catch(() => setStockistList([]));
                }
              }}
            />
          </div>

          {uploaderType === "MV" || uploaderType === "KAM" ? (
            /* MV / KAM - Order Codes Multi-Select */
            <div className="flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700 mb-2">Order Codes</label>
              <MultiAutocompleteAsync
                placeholder="Select order codes"
                inputClassName="w-full"
                suggestionList={[]}
                displayKey="order_code"
                uniqueKey="order_code"
                controlledValue={orders}
                isAsyncQuery={true}
                asyncListFunction={(query = "", page = 1) => fetchOrderDetailsAsync(query, page)}
                onSelectionChange={(value: any, action: string) => {
                  if (action === "add" || action === "bulk-add") {
                    setOrders(prev => {
                      const prevArray = Array.isArray(prev) ? prev : [];
                      const newValues = Array.isArray(value) ? value : [value];
                      return [...prevArray, ...newValues].filter(
                        (v, i, arr) => arr.findIndex(item => item.order_code === v.order_code) === i
                      );
                    });
                  } else if (action === "remove" || action === "bulk-remove") {
                    setOrders(prev => {
                      const prevArray = Array.isArray(prev) ? prev : [];
                      const removeValues = Array.isArray(value) ? value : [value];
                      return prevArray.filter(v => !removeValues.some(r => r.order_code === v.order_code));
                    });
                  } else if (action === "reset") {
                    setOrders([]);
                  }
                }}
                showSelectAll={true}
              />
            </div>
          ) : (
            <>
              {/* NMV - Stockist Selection */}
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-gray-700 mb-2">Stockist</label>
                <Autocomplete
                  suggestionList={stockistList}
                  displayKey="owner_name"
                  placeholder="Select Stockist"
                  defaultValue={nmvStockist}
                  onSelectionChange={(value: any) => setNmvStockist(value)}
                />
              </div>

              {/* NMV - Select Type (radio - either one) */}
              <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-gray-700 mb-2">Select Type</label>
                <div className="flex gap-4">
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="radio"
                      name="nmvType"
                      checked={nmvCheckbox === "patient"}
                      onChange={() => { setNmvCheckbox("patient"); setCustomerName(""); }}
                      className="accent-[#7F56D9]"
                    />
                    Patient
                  </label>
                  <label className="flex items-center gap-2 text-sm">
                    <input
                      type="radio"
                      name="nmvType"
                      checked={nmvCheckbox === "customer"}
                      onChange={() => { setNmvCheckbox("customer"); setCustomerName(""); }}
                      className="accent-[#7F56D9]"
                    />
                    Customer
                  </label>
                </div>
              </div>

              {/* NMV - Customer/Patient Name */}
              {nmvCheckbox && (
                <div className="flex flex-col gap-1">
                  <label className="text-sm font-medium text-gray-700 mb-2">
                    {nmvCheckbox === "patient" ? "Patient Name" : "Customer Name"}
                  </label>
                  <input
                    type="text"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder={nmvCheckbox === "patient" ? "Enter patient name" : "Enter customer name"}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#7F56D9] focus:border-[#7F56D9]"
                  />
                </div>
              )}
            </>
          )}

          {/* Reference No (shared) */}
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700 mb-2">Reference No</label>

            <input
              type="text"
              value={referenceNo}
              onChange={(e) => setReferenceNo(e.target.value)}
              placeholder="Enter reference number"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#7F56D9] focus:border-[#7F56D9]"
            />

          </div>

          {/* File Upload */}
          <label
            htmlFor="fileInput"
            className="w-full h-40 pl-[26px] pr-[25px] py-7 bg-white rounded-xl border border-neutral-400 justify-center items-center inline-flex cursor-pointer"
          >
            <div
              className="inline-flex flex-col items-center self-stretch justify-start gap-5"
              onDrop={onDropHandler}
              onDragOver={(e) => e.preventDefault()}
            >
              <div className="relative w-10 h-10">
                <img
                  src={uploadSvg}
                  alt="upload"
                  className="absolute top-0 left-0 w-10 h-10"
                />
              </div>

              <div className="inline-flex gap-1">
                <span className="text-zinc-900 text-base font-medium">
                  Drag & drop files
                </span>
                <span className="text-zinc-900 text-base font-medium">or</span>
                <span className="text-indigo-500 text-base font-semibold underline">
                  Browse
                </span>
              </div>
            </div>

            <input
              id="fileInput"
              type="file"
              accept=".pdf,.tiff,.tif,.bmp,.jpeg,.png,.jpg,.webp,.jpe"
              hidden
              onChange={onFileChange}
            />
          </label>

          {/* Selected File Display */}
          {selectedFile && (
            <div className="flex items-center justify-between px-4 py-2 border rounded-md bg-gray-50">
              <div>
                <p className="text-sm font-medium text-gray-800">{selectedFile.name}</p>
                <p className="text-xs text-gray-500">{(selectedFile.size / 1024).toFixed(2)} KB</p>
              </div>
              <button className="text-sm font-medium text-red-500" onClick={() => setSelectedFile(null)}>
                Remove
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        <footer className="flex justify-end gap-2 px-5 py-3">
          <Button className="border" onClick={handleClose}>Back</Button>
          <Button
            type="submit"
            disabled={!selectedFile}
            className={`bg-[#7F56D9] text-white ${!selectedFile ? "opacity-50 cursor-not-allowed" : ""}`}
            onClick={HandleUpload}
          >
            Upload File
          </Button>
        </footer>
      </div>
    </Modal>
  );
};

export default InvoiceUploadModal;
//M10-12287